<div class="icon-picker-container">
  <div class="icon-picker-dropdown">
    <!-- Search Input -->
    <div class="search-container">
      <ion-input
        [(ngModel)]="searchTerm"
        (ionInput)="filterIcons()"
        placeholder="Search icons..."
        class="search-input"
      >
        <ion-icon name="search-outline" slot="start"></ion-icon>
      </ion-input>
    </div>

    <!-- Icons Grid -->
    <div class="icons-grid">
      <div
        *ngFor="let icon of filteredIcons"
        class="icon-item"
        (click)="selectIcon(icon)"
        [class.selected]="icon === selectedIcon"
        [title]="icon"
      >
        <lucide-icon
          [img]="getIconComponent(icon)"
          class="grid-icon"
        ></lucide-icon>
        <span class="icon-name">{{ icon }}</span>
      </div>
    </div>

    <!-- No Results Message -->
    <div class="no-results" *ngIf="filteredIcons.length === 0">
      <ion-icon name="search-outline" class="no-results-icon"></ion-icon>
      <p>No icons found matching "{{ searchTerm }}"</p>
    </div>
  </div>
</div>
